import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import toast from 'react-hot-toast';
import { Flash, ArrowLeft2 } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { handleResetPassword } from '../utils/FirebaseFunctions';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [APIloading, setAPILoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword_cont = () => {
    setAPILoading(true);
    if (email === '') {
      toast.error('Please enter your email address');
      setAPILoading(false);
      return;
    }
    
    handleResetPassword(email).then(() => {
      toast.success('Password reset email sent successfully. Please check your email inbox', {duration: 5000, position: 'bottom-center'});
      setTimeout(() => {
        navigate('/login');
      }, 5000);
    }).catch((err) => {
      toast.error(err.message.split(':')[1], {duration: 5000, position: 'bottom-center'});
    }).finally(() => {
      setTimeout(() => {
        setAPILoading(false);
      }, 3000);
    });
  };

  return (
    <div style={{ overflow: "hidden" }} className='h-screen w-screen flex flex-col items-center p-5 justify-center'>
      <p className='text-sm font-nunito mb-4 mt-auto'>Welcome !!</p>
      <p className='text-3xl font-nunito flex flex-row gap-[10px] items-center font-medium mb-[50px]'>
        <Flash
          size="42"
          color="#0080f3"
          variant="Bulk"
        />
        Medisupport
      </p>

      <input type="email" placeholder='Email'
        value={email} onChange={(e) => setEmail(e.target.value)}
        className='px-5 h-[46px] rounded-sm font-nunito bg-white mb-3 w-[85%]'
      />

      <button onClick={handleResetPassword_cont} disabled={APIloading} className={'px-5 h-[46px] rounded-sm bg-blue-500 text-white font-nunito w-[85%] text-center' + (APIloading ? "bg-blue-200 opacity-[0.5] cursor-not-allowed" : "bg-blue-500")}>
        {APIloading ? (
          <div className='flex items-center justify-center'>
            <div className='animate-spin rounded-full h-6 w-6 border-t-2 border-white mr-8'></div>
            Sending Email ...
          </div>
        ) : (
          'Reset Password'
        )}
      </button>

      <p onClick={() => navigate('/login')} className='text-center mt-auto'>Remember your password? &nbsp; Login here</p>
      <p onClick={() => navigate('/signup')} className='text-center mt-[20px] mb-[50px]'>Not a user? Signup Here</p>
    </div>
  );
};
